import { Part, PART_INITIAL_VALUES } from "@/pages/catalogs/models/Part";
import {
	CARRIER_ROLLSET_DATA_INITIAL_VALUES,
	CarrierRollsetData,
} from "./CarrierRollsetData";

export interface Roll extends Part, CarrierRollsetData {
	RollPosition: string | null;
	RollStatusCode: string | null;
	RollTypeCode: string | null;
	StandId: number | null;
	StandName: string | null;
}

export const ROLL_INITIAL_VALUES: Roll = {
	...PART_INITIAL_VALUES,
	RollPosition: "B",
	RollStatusCode: "R",
	RollTypeCode: "E",
	StandId: null,
	StandName: null,
	...CARRIER_ROLLSET_DATA_INITIAL_VALUES,
};
